import { Close } from '@mui/icons-material'
import { IconButton } from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { selectUser } from 'store/selectors/user'
import { renderRichText } from 'utils/helpers'
import { trackBannerClick, trackBannerDismiss, trackBannerImpression } from 'utils/mixpanel'

const LS_KEY = 'grant-connect-hide-banner'
const BANNER_NAME = 'Subscriber Survey June 2026'

const Banner = () => {
  const { i18n } = useTranslation()
  const t = i18n.getResourceBundle(i18n.language)

  const { isAuthenticated, isLibraryMode } = useSelector(selectUser)

  const [isHidden, setIsHidden] = useState(localStorage.getItem(LS_KEY) === 'true')
  const [confirmedHidden, setConfirmedHidden] = useState(true)

  const isVisible = isAuthenticated && !isLibraryMode && !isHidden

  const hideBanner = () => {
    localStorage.setItem(LS_KEY, 'true')
    setIsHidden(true)
    setConfirmedHidden(false)
    trackBannerDismiss(BANNER_NAME)
  }

  const confirmHideBanner = () => {
    setConfirmedHidden(true)
  }

  const showBanner = () => {
    localStorage.removeItem(LS_KEY)
    setIsHidden(false)
    setConfirmedHidden(true)
  }

  const onBannerClick = event => {
    event.preventDefault()
    window.open(t.global.bannerLink, '_blank')
    trackBannerClick(BANNER_NAME)
  }

  useEffect(() => {
    if (isVisible) {
      trackBannerImpression(BANNER_NAME)
    }
  }, [])

  if (!isVisible) {
    if (confirmedHidden) {
      return null
    }
    return (
      <div className="banner-hidden">
        <a role="button" onClick={showBanner}>
          {t.global.bannerRestore}
        </a>
        <IconButton aria-label="close banner" onClick={confirmHideBanner}>
          <Close fontSize="small" />
        </IconButton>
      </div>
    )
  }

  return (
    <div className="banner">
      <div className="text-container">
        <p onClick={onBannerClick}>{renderRichText(t.global.banner)}</p>
      </div>
      <IconButton aria-label="close banner" onClick={hideBanner}>
        <Close fontSize="small" />
      </IconButton>
    </div>
  )
}

export default Banner
